var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCommon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 72,
    viewBox: "0 0 60 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 0.125H39.1687L56.625 17.5812V34.5H50.375V25.125H31.625V6.375H6.625V62.625H28.5V68.875H0.375V0.125ZM37.875 7.66875V18.875H49.0813L37.875 7.66875ZM34.75 45.4375C34.75 43.3655 35.5731 41.3784 37.0382 39.9132C38.5034 38.4481 40.4905 37.625 42.5625 37.625C44.6345 37.625 46.6216 38.4481 48.0868 39.9132C49.5519 41.3784 50.375 43.3655 50.375 45.4375V59.5H44.125V45.4375C44.125 45.0231 43.9604 44.6257 43.6674 44.3326C43.3743 44.0396 42.9769 43.875 42.5625 43.875C42.1481 43.875 41.7507 44.0396 41.4576 44.3326C41.1646 44.6257 41 45.0231 41 45.4375V59.5C41 61.1576 41.6585 62.7473 42.8306 63.9194C44.0027 65.0915 45.5924 65.75 47.25 65.75C48.9076 65.75 50.4973 65.0915 51.6694 63.9194C52.8415 62.7473 53.5 61.1576 53.5 59.5V47H59.75V59.5C59.75 62.8152 58.433 65.9946 56.0888 68.3388C53.7446 70.683 50.5652 72 47.25 72C43.9348 72 40.7554 70.683 38.4112 68.3388C36.067 65.9946 34.75 62.8152 34.75 59.5V45.4375Z",
    fill: "url(#paint0_linear_743_621)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_743_621",
    x1: 30.0625,
    y1: 0.125,
    x2: 30.0625,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8761F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F398F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommon);
export default __webpack_public_path__ + "static/media/IconCommon.d4af254197fbb5590b355bdf3736e88c.svg";
export { ForwardRef as ReactComponent };